import logo from './chad_no_background.png';
import './App.css';
import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';

// Tutorial for Making Navbar Component: https://www.youtube.com/watch?v=fL8cFqhTHwA
// Font Icons: https://fontawesome.com/
// Use npm start to start site
// npm run build to build site for deployment 

class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {}

  }


  render() {

    return (
      <div className="App">

        <Navbar />

        <header className="App-header">

          <img src={logo} /*className="App-logo"*/ alt="logo" />
          <code>Welcome to Gym Bro</code>
          
          <h3><a href="https://top.gg/bot/949731498808979557" target="_blank">Gym Bro Invite</a></h3>

          <br></br>
          <a href="https://top.gg/bot/949731498808979557" target="_blank">
            <img src="https://top.gg/api/widget/949731498808979557.svg"/>
          </a>

          <br></br>
          <br></br>
          <br></br>
          
        </header>
        
        <Footer />

        

      </div>
    );
  }

}

export default App;
